"use client";

import React, { useRef, useState } from 'react';
import __ from '../utils/translation';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Type, ImagePlus } from 'lucide-react';

const TextCustom = ({ canvas }) => {

    return (
        <Card className="border-none shadow-sm">
            <CardHeader className="pb-3">
                <CardTitle className="text-lg font-semibold flex items-center gap-2">
                    <Type className="h-5 w-5 text-primary" />
                    {__('Text Custom')}
                </CardTitle>
            </CardHeader>

            <CardContent className="space-y-4">

                {/**<div className="space-y-2">
                    <Label>Conteúdo</Label>
                    <Input type='text' />
                </div>
                <div className="space-y-2">
                    <Label>Font Size</Label>
                    <Input type='number' defaultValue={1} />
                </div>
                <div className="space-y-2">
                    <Label>Font family</Label>
                    <Input type='number' defaultValue={1} />
                </div> */}

                <Button id='add-custom-text' className="w-full" variant="default">
                    <Type className="mr-2 h-4 w-4" />
                    Adicionar texto no fundo
                </Button>

                <div className="space-y-2">
                    <Label htmlFor="add-custom-img" className="text-sm text-muted-foreground flex items-center gap-2 cursor-pointer">
                        <ImagePlus className="h-4 w-4" />
                        Adicionar imagem
                    </Label>
                    <Input 
                        type='file' 
                        id='add-custom-img' 
                        className="cursor-pointer file:mr-4 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-primary file:text-primary-foreground hover:file:bg-primary/90"
                    />
                </div>

                <div id="list-custom-text" className="space-y-2 pt-2">

                </div>
            </CardContent>
        </Card>
    )
}


export default TextCustom

